import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Transfer, Table, Button} from 'antd'
import {toJS} from 'mobx'
import difference from 'lodash/difference'
import {withTranslation} from 'react-i18next'

@inject('userManagementStore')
@observer
class RoleFormModal extends Component {
  state = {}

  componentDidMount() {
  }

  onChange = (targetKeys) => {
    const {userManagementStore} = this.props
    userManagementStore.getRoleUserTargetKeys(targetKeys)
  }
  handleOk = () => {
    const {userManagementStore, handleCancelRole, record} = this.props
    const {targetKeys} = userManagementStore
    var oldArr = record?.roles.map(item => item.id)
    var diffArr = []
    var params = []
    for (var i = 0; i < oldArr.length; i++) {
      if (targetKeys.indexOf(oldArr[i]) === -1) {
        diffArr.push(oldArr[i])
      }
    }
    targetKeys.map(item => {
      return params.push({
        id: item,
        addOrDelete: true
      })
    })
    diffArr.map(item => {
      return params.push({
        id: item,
        addOrDelete: false
      })
    })
    userManagementStore.onAddRoleAction({'bindRolesVOs': params}, record.id).then(() => {
      userManagementStore.getRoleUserTargetKeys([])
    })
    handleCancelRole()
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {userManagementStore, roleModalVisible, handleCancelRole, t} = this.props
    const {userRoleList, targetKeys} = userManagementStore
    return (
      <>
        <Modal
          title={t(`userManagement.roleConfig`)}
          closable={true}
          onCancel={handleCancelRole}
          visible={roleModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancelRole}
          maskClosable={false}
          okText={t(`general.save`)}
          width="90%"
          centered
          destroyOnClose={true}
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancelRole}>{t(`general.cancel`)}</Button>,
          ]}
          className="modalHeight"
        >
          <Form key="addRole">
            <Transfer
              dataSource={toJS(userRoleList)}
              targetKeys={toJS(targetKeys)}
              showSearch
              titles={[t(`userManagement.unselectedList`), t(`userManagement.selectedList`)]}
              rowKey={record => record.id}
              onChange={this.onChange}
              filterOption={(inputValue, item) =>
                item.name.indexOf(inputValue) !== -1
              }
            >
              {({
                  filteredItems,
                  onItemSelectAll,
                  onItemSelect,
                  selectedKeys: listSelectedKeys,
                }) => {
                const rowSelection = {
                  onSelectAll(selected, selectedRows) {
                    const treeSelectedKeys = selectedRows
                      .filter(item => !item.disabled)
                      .map(({id}) => id)
                    const diffKeys = selected
                      ? difference(treeSelectedKeys, listSelectedKeys)
                      : difference(listSelectedKeys, treeSelectedKeys)
                    onItemSelectAll(diffKeys, selected)
                  },
                  onSelect({id}, selected) {
                    onItemSelect(id, selected)
                  },
                  selectedRowKeys: listSelectedKeys,
                }
                return (
                  <Table
                    rowSelection={rowSelection}
                    dataSource={filteredItems}
                    pagination={false}
                    scroll={{y: 300}}
                    rowClassName={this.getRowClassName}
                  >
                    <Table.Column title={t(`userManagement.name`)} dataIndex="name" key="name"/>
                    <Table.Column title={t(`userManagement.key`)} dataIndex="key" key="key"/>
                  </Table>
                )
              }}
            </Transfer>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(RoleFormModal)
